var map = {
	"./Scene0.vue": 2634,
	"./Scene1.vue": 7282,
	"./Scene2.vue": 3954,
	"./Scene3.vue": 1482,
	"./Scene4.vue": 9203,
	"./Scene5.vue": 3293,
	"./Scene6.vue": 6824,
	"./Scene7.vue": 5242,
	"./Scene8.vue": 8275,
	"./Scene9.vue": 2419
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5214;